export function formatGP(m, obo) {
  if (obo) return "OBO";
  if (m >= 1000) return `${+(m / 1000).toFixed(2)}B`;
  return `${+Number(m).toFixed(1)}M`;
}

export const RARITY = {
  common: { label: "Common", color: "#9aa0a6", glow: "rgba(154,160,166,0.25)" },
  rare: { label: "Rare", color: "#ff7a3d", glow: "rgba(255,122,61,0.35)" },
  epic: { label: "Epic", color: "#ff2a55", glow: "rgba(255,42,85,0.4)" },
  legendary: { label: "Legendary", color: "#ff007f", glow: "rgba(255,0,127,0.5)" },
  mythic: { label: "Mythic", color: "#ffffff", glow: "rgba(255,255,255,0.55)" },
};

export const ART = {
  explosion: "/brand/art_explosion.webp",
  lightning: "/brand/art_lightning.webp",
  jet: "/brand/art_jet.webp",
  ruins: "/brand/art_ruins.webp",
};

export const STATUS_COLOR = {
  pending: "#ffb020",
  paid: "#35d07f",
  delivering: "#4da3ff",
  delivered: "#ffffff",
  cancelled: "#ff2a55",
  new: "#ffb020",
  quoted: "#4da3ff",
  fulfilled: "#35d07f",
  rejected: "#ff2a55",
};

export function nameSizeClass(t = "") {
  const n = t.length;
  if (n <= 5) return "text-6xl";
  if (n <= 8) return "text-5xl";
  if (n <= 11) return "text-4xl";
  return "text-3xl";
}
